<template>
  <div>
    <a-config-provider :locale="locale">
      <router-view/>
    </a-config-provider>
  </div>
</template>

<script setup>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
// import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
// dayjs.locale('zh');
import {ref} from "vue";
import {setToken} from "@/service/header";
const locale = ref(zhCN);

// 获取token,向接口header中传值确保在登录状态中
if(localStorage.getItem('competition-management-userInfo')){
  const userInfo = localStorage.getItem('competition-management-userInfo');
  setToken(JSON.parse(userInfo).token)
// setToken('eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJiZTZhZGJkNi1iNDIyLTRjM2MtOWI4OC02MTY0ODNjODFkN2QiLCJyb2xlcyI6WyJTWVNURU1fQURNSU4iXSwiaWF0IjoxNzI1OTM4MDYwLCJleHAiOjE3MjU5ODEyNjB9.19erSi-D_tN87KWNxf3gxk9mSwcR5pgcFcITU-AD3jQ')
}

</script>

<style>

</style>
